import Cookies from 'js-cookie';

export type cookies =
  | 'isVisited'
  | 'homeDownloadProgress'
  | 'hasBody'
  | 'hasGoggles'
  | 'hasHandL'
  | 'hasHandR'
  | 'shutDown';

export function setCookies(cookie: cookies, value: string) {
  Cookies.set(cookie, value, { path: '/', expires: 1 });
}

export function getCookies(cookie: cookies): string | undefined {
  return Cookies.get()[cookie];
}

export function resetCookies() {
  Object.keys(Cookies.get()).forEach((cookie) => {
    Cookies.remove(cookie, { path: '/' });
  });

  console.log('Cookies reset', Cookies.get());
}
